// Module
var code = `<template>
  <require from="./portfolio-overview-light-experimental-widget.scss"></require>

  <div class="portfolio-overview-light-experimental-widget portfolio-overview-light-experimental-widget-\${id}">
    <!-- beautify ignore:start -->
    <style if.bind="rowHeight">
      .portfolio-overview-light-experimental-widget-\${id} tr {
        height: \${rowHeight}px !important;
      }
    </style>

    <style>
      .portfolio-overview-light-experimental-widget-\${id} td {
        font-family: \${font || 'var(--dyn-default-font-family)'};
        font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${color | widgetTemplateColor:isInDashboard} !important;
      }

      .portfolio-overview-light-experimental-widget-\${id} th {
        font-family: \${captionFont ? captionFont : 'var(--dyn-default-font-family)'};
        font-size: \${captionFontSize ? captionFontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${captionColor | widgetTemplateColor:isInDashboard} !important;
      }
    </style>
    <!-- beautify ignore:end -->

    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>
    <dyn-table settings.bind="columnSettings" storage-key.bind="columnStorageKey" user-settings.bind="userColumnSettings" column-settings-changed.trigger="onColumnSettingsChanged(\$event.detail)" column-user-settings-changed.trigger="onColumnUserSettingsChanged(\$event.detail)" column-reset.trigger="onColumnReset()">
    <table if.bind="!loading && !error" class="widget-table">
      <thead>
        <tr>
          <th movable="false" hideable="false">Name</th>

          <th data-col-id="quantity" class="widget-table__numeric">Quantity</th>

          <th data-col-id="price" class="widget-table__numeric">Price</th>

          <th data-col-id="price-ccy" class="portfolio-overview-light-experimental-widget__currency">Price ccy</th>

          <th data-col-id="value" class="widget-table__numeric">Value</th>

          <th if.bind="displayFifo" data-col-id="cost" class="widget-table__numeric">
            Cost Price</th>
          <th if.bind="displayAvg" data-col-id="cost-avg" class="widget-table__numeric">
            Cost Price (AVG)</th>

          <th if.bind="displayFifo" data-col-id="unreal" class="widget-table__numeric">
            Unreal.</th>
          <th if.bind="displayAvg" data-col-id="unreal-avg" class="widget-table__numeric">
            Unreal. (AVG)</th>

          <th if.bind="displayFifo" data-col-id="unreal-pct" class="widget-table__numeric">
            Unreal. %</th>
          <th if.bind="displayAvg" data-col-id="unreal-pct-avg" class="widget-table__numeric">
            Unreal. % (AVG)</th>

          <th if.bind="displayFifo" data-col-id="real" class="widget-table__numeric">
            + Real.</th>
          <th if.bind="displayAvg" data-col-id="real-avg" class="widget-table__numeric">
            + Real. (AVG)</th>

          <th data-col-id="dividend" class="widget-table__numeric">
            + Divid.</th>

          <th data-col-id="interest" class="widget-table__numeric">
            + Int.</th>

          <th if.bind="displayFifo" data-col-id="pl" class="widget-table__numeric">
            = P&L</th>
          <th if.bind="displayAvg" data-col-id="pl-avg" class="widget-table__numeric">
            = P&L (AVG)</th>

          <th if.bind="displayFifo" data-col-id="unreal-all" class="widget-table__numeric">
            Unreal. All</th>
          <th if.bind="displayAvg" data-col-id="unreal-all-avg" class="widget-table__numeric">
            Unreal. All (AVG)</th>

          <th if.bind="displayFifo" data-col-id="unreal-all-pct" class="widget-table__numeric">
            Unreal. All %</th>
          <th if.bind="displayAvg" data-col-id="unreal-all-pct-avg" class="widget-table__numeric">
            Unreal. All % (AVG)</th>
        </tr>
      </thead>
      <tbody>
        <template repeat.for="v of instrumentValues">
          <tr class="\${v === total ? 'widget-table__total' : ''} \${v.group1Total ? 'widget-table__group-total' : ''} \${v.group1Header ? 'widget-table__group-header' : ''}">
            <td style="padding-left: \${v.indent}px">
              \${v.name}</td>

            <template if.bind="!groupHeader">
              <td class="widget-table__numeric">
                \${v.quantityClosingBalance | numericFormatter:quantityPrecision}
              </td>

              <td class="widget-table__numeric">
                \${v.sellPrice | numericFormatter:precision}
              </td>

              <td class="portfolio-overview-light-experimental-widget__currency">\${v.sellPriceCcy}</td>

              <td class="widget-table__numeric">
                \${v.estimatedValueClosingBalance | numericFormatter:precision}
              </td>

              <td if.bind="displayFifo" class="widget-table__numeric">
                \${v.costPriceClosingBalance | numericFormatter:precision}</td>
              <td if.bind="displayAvg" class="widget-table__numeric">
                \${v.avgCostPriceClosingBalance | numericFormatter:precision}</td>

              <td if.bind="displayFifo" class="widget-table__numeric">
                \${v.unrealizedProfitLossChangeInPeriod | numericFormatter:precision}</td>
              <td if.bind="displayAvg" class="widget-table__numeric">
                \${v.avgUnrealizedProfitLossChangeInPeriod | numericFormatter:precision}</td>

              <td if.bind="displayFifo" class="widget-table__numeric">
                \${v.unrealizedProfitLossChangeInPeriod / v.costPriceClosingBalance * 100 | numericFormatter:0}</td>
              <td if.bind="displayAvg" class="widget-table__numeric">
                \${v.avgUnrealizedProfitLossChangeInPeriod / v.avgCostPriceClosingBalance * 100 | numericFormatter:0}
              </td>

              <td if.bind="displayFifo" class="widget-table__numeric">
                \${v.realizedProfitLossChangeInPeriod | numericFormatter:precision}</td>
              <td if.bind="displayAvg" class="widget-table__numeric">
                \${v.avgRealizedProfitLossChangeInPeriod | numericFormatter:precision}</td>

              <td class="widget-table__numeric">
                \${v.dividendChangeInPeriod | numericFormatter:precision}
                <promise-resolver resolve.bind="lastItemRendered" if.bind="\$last"></promise-resolver>
              </td>

              <td class="widget-table__numeric">
                \${v.interestChangeInPeriod | numericFormatter:precision}</td>

              <td if.bind="displayFifo" class="widget-table__numeric">
                \${v.profitLossChangeInPeriod | numericFormatter:precision}</td>
              <td if.bind="displayAvg" class="widget-table__numeric">
                \${v.avgProfitLossChangeInPeriod | numericFormatter:precision}</td>

              <td if.bind="displayFifo" class="widget-table__numeric">
                \${v.unrealizedProfitLossClosingBalance | numericFormatter:precision}</td>
              <td if.bind="displayAvg" class="widget-table__numeric">
                \${v.avgUnrealizedProfitLossClosingBalance | numericFormatter:precision}</td>

              <td if.bind="displayFifo" class="widget-table__numeric">
                \${v.unrealizedProfitLossClosingBalance / v.costPriceClosingBalance * 100 | numericFormatter:0}</td>
              <td if.bind="displayAvg" class="widget-table__numeric">
                \${v.avgUnrealizedProfitLossClosingBalance / v.avgCostPriceClosingBalance * 100 | numericFormatter:0}
              </td>

            </template>
          </tr>
        </template>
      </tbody>
    </table>
    </dyn-table>

    <message if.bind="error" class="widget__error" icon="error" colour="mdc-theme--error">
      \${error.message}
    </message>
  </div>
</template>
`;
// Exports
export default code;